// src/components/CostumeSelect.js
import React from "react";

const CostumeSelect = ({ costumes, onSelectCostume, selectedCostumeId }) => {

  return (
    <div className="col-span-1">
      <label htmlFor="costume" className="block pb-4">
        Costume
      </label>
      <div className="flex justify-center space-x-1 lg:space-x-4">
        {costumes.map((costume) => (
          <div
            key={costume.id}
            className={`cursor-pointer p-0 lg:p-2 border bg-gray-950 bg-opacity-50 rounded-lg duration-200 ease-in-out ${
              selectedCostumeId === costume.id ? "border-pink-100 scale-105 hover:scale-105" : "border-transparent scale-100 hover:scale-105"
            }`}
            onClick={() => onSelectCostume(costume.id)}
          >
            <img
              src={costume.src}
              alt=""
              className="h-full max-h-50 min-h-50 transform transition-transform duration-200 ease-in-out"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CostumeSelect;